import { address, error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const UpdateBankingApplication = gql`
  mutation UpdateBankingApplication(
    $applicationId: String!
    $firstName: String
    $lastName: String
    $dateOfBirth: LocalDate
    $countryOfCitizenship: String
    $ssn: String
    $mailingAddress: AddressInput
    $address: AddressInput
    $occupation: String
    $residency: ResidencyTypeEnum
    $productTypes: BankingApplicationInput
  ) {
    updateApplication(
      applicationId: $applicationId
      input: {
        firstName: $firstName
        lastName: $lastName
        ssn: $ssn
        dateOfBirth: $dateOfBirth
        countryOfCitizenship: $countryOfCitizenship
        mailingAddress: $mailingAddress
        address: $address
        occupation: $occupation
        residency: $residency
        banking: $productTypes
      }
    ) {
      __typename
      ... on UpdateApplicationSuccess {
        application {
          id
          ... on BankApplication {
            firstName
            lastName
            dateOfBirth
            address {
              ...address
            }
            mailingAddress {
              ...address
            }
            countryOfCitizenship
            productSelections
            status
          }
          ... on LendingApplication {
            id
            __typename
          }
          __typename
        }
      }
      ... on UpdateApplicationError {
        __typename
        ...error
        title
        message
      }
    }
  }
  ${address}
  ${error}
`;
